import * as React from "react";
import {useEffect, useState} from "react";
import {Customer} from "../Shared/Store/Types";

const Noty = require('noty');
declare const ViewChosenCustomers: string;
declare const ViewCustomers: Customer[];

export const CustomerDropdown = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [customers, setCustomers] = useState<Customer[]>([]);
    const [selectedCustomerIds, setSelectedCustomerIds] = useState<string[]>([]);
    const [selectCount, setSelectCount] = useState<number>(null);
    const customerDropdown = React.createRef<HTMLDivElement>();
    const customerDropdownParent = React.createRef<HTMLDivElement>();

    useEffect(() => {
        if (customers != ViewCustomers) {
            let selected = ViewChosenCustomers.split(',');

            setCustomers(ViewCustomers);
            setSelectedCustomerIds(selected);
            setSelectCount(selected.length)
        }
    }, []);

    function clearAll() {
        setSelectedCustomerIds([]);
        setSelectCount(0);
    }

    function handleSaveChanges() {
        setIsLoading(true);

        $.ajax({
            url: '/User/UpdateSelectedCustomer',
            type: 'POST',
            data: {
                customerIds: selectedCustomerIds
            },
            success: (response) => {
                let noty = new Noty({
                    text: 'Your customer has been updated',
                    type: "success",
                    theme: 'metroui',
                    timeout: 3000
                }).show();

                location.reload();
            },
            error: (error) => {
                let noty = new Noty({
                    text: 'We encountered an issue updating your Customer. Please try again.',
                    type: "error",
                    theme: 'metroui',
                    timeout: 3000
                }).show();

                console.log(error);
                setIsLoading(false);
            }
        });
    }

    function handleSelectOption(customerId: string) {
        let temp = selectedCustomerIds;

        if (temp.indexOf(customerId) == -1) {
            temp.push(customerId);
        } else {
            temp = temp.filter(c => {
                return c != customerId
            });
        }

        setSelectedCustomerIds(temp);
        setSelectCount(temp.length);
    }

    function selectAll() {
        let selection = customers.map(c => {
            return c.id;
        });

        setSelectedCustomerIds(selection);
        setSelectCount(selection.length);
    }

    return (
        <div className="dropdown change-customer-dropdown" ref={customerDropdownParent}>
            {
                isLoading ?
                    <div className={'loader loader-fullscreen'}>
                        <div className="loader-icon">
                            <div className="outer"/>
                            <div className="middle"/>
                            <div className="inner"/>
                        </div>

                        <span className={'loader-text'}>Updating Selected Customer..</span>
                    </div>
                    :
                    null
            }
            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
               aria-haspopup="true" aria-expanded="false">
                {selectCount} Customers Selected
            </a>
            <div className="dropdown-menu" ref={customerDropdown}>
                <div className="overflow-auto" style={{height: '400px'}}>
                    {
                        ViewCustomers.map((c: Customer) => {
                            return (
                                <div className="dropdown-item" key={'customerSelection-' + c.id} onClick={() => {
                                    customerDropdown.current.classList.add('show');
                                    customerDropdownParent.current.classList.add('show');
                                }}>
                                    <div className="button-checkbox mr-2">
                                        <input type="checkbox"
                                               name="SelectedCustomers"
                                               value={c.id}
                                               id={`customerSelection-${c.id}`}
                                               checked={selectedCustomerIds.indexOf(c.id) != -1}
                                               onChange={(e) => {
                                                   customerDropdown.current.classList.add('show');
                                                   customerDropdownParent.current.classList.add('show');
                                                   handleSelectOption(e.target.value);
                                               }}/>
                                        <label htmlFor={`customerSelection-${c.id}`} className="btn-sm">
                                            <span className="text">{c.name}</span>
                                        </label>
                                    </div>
                                </div>

                            )
                        })
                    }
                </div>
                <div className="dropdown-divider"/>
                <div className="dropdown-item" onClick={() => {
                    customerDropdown.current.classList.add('show');
                    customerDropdownParent.current.classList.add('show');
                    selectAll();
                }}>Select All
                </div>
                <div className="dropdown-item" onClick={() => {
                    customerDropdown.current.classList.add('show');
                    customerDropdownParent.current.classList.add('show');
                    clearAll();
                }}>Clear All
                </div>
                <div className="dropdown-divider"/>
                <div className="dropdown-item">
                    <span className="btn btn-primary" onClick={() => {
                        handleSaveChanges();
                    }}>Apply Selection</span>
                </div>
            </div>
        </div>
    )
};